// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyAwards_faculty-awards__ZrbZq .FacultyAwards_award__EuoAm {
  margin-bottom: 25px;
}
.FacultyAwards_faculty-awards__ZrbZq .FacultyAwards_award__EuoAm .FacultyAwards_section-title__X\\+NIS {
  color: var(--dark-grey);
  font-weight: 500;
  font-size: 14px;
}
.FacultyAwards_faculty-awards__ZrbZq .FacultyAwards_award__EuoAm .FacultyAwards_title__ggA8W:hover {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
@media only screen and (max-width: 480px) {
  .FacultyAwards_faculty-awards__ZrbZq .FacultyAwards_section-title__X\\+NIS {
    text-decoration: underline;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/FacultyAwards/FacultyAwards.module.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AACI;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;AACN;AACI;EACE,WAAA;EACA,0BAAA;EACA,eAAA;AACN;AAEE;EACE;IACE,0BAAA;EAAJ;AACF","sourcesContent":[".faculty-awards {\n  .award {\n    margin-bottom: 25px;\n    .section-title {\n      color: var(--dark-grey);\n      font-weight: 500;\n      font-size: 14px;\n    }\n    .title:hover {\n      color: blue;\n      text-decoration: underline;\n      cursor: pointer;\n    }\n  }\n  @media only screen and (max-width: 480px) {\n    .section-title {\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-awards": `FacultyAwards_faculty-awards__ZrbZq`,
	"award": `FacultyAwards_award__EuoAm`,
	"section-title": `FacultyAwards_section-title__X+NIS`,
	"title": `FacultyAwards_title__ggA8W`
};
export default ___CSS_LOADER_EXPORT___;
